import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import { Table, Tag, Button, Select, Input, Modal, Switch } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import InsertAdminUser from "./InsertAdminUser";
import EditAdminUser from "./EditAdminUser";
import axios from "axios";

const backend = process.env.REACT_APP_BACKEND;

const AdminUser = ({ adminManageInfo, menuGroupLists, resetUsers }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.mainReducer.userInfo);
  const [data, setData] = useState();
  const [createPopup, setCreatePopup] = useState(false);
  const [editPopup, setEditPopup] = useState([false, {}]);
  const [loading, setLoading] = useState(false);
  const [emailValidator, setEmailValidator] = useState(null); //운영자 추가 모달의 이메일체크를 위한 상태
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSize: 10, // 한 페이지에 표시할 레코드 수
    },
  });
  // console.log("이거 바뀌나?",adminManageInfo)
  const [filter, setFilter] = useState({
    status: "전체",
    menuGroup: "전체",
    search: "",
  });

  const userRef = useRef(null);

  const columns = [
    {
      title: "NO",
      dataIndex: "rowKey",
      width:"80px"
    },
    {
      title: "계정(이메일)",
      dataIndex: "email",
      width:"200px",
      render: (_, record) => (
        <a
          onClick={() => {
            setEditPopup([true, record]);
          }}
        >
          {_}
        </a>
      ),
    },
    {
      title: "이름",
      dataIndex: "name",
      width:"100px"
    },
    {
      title: "휴대폰 번호",
      dataIndex: "phone",
      width: "150px"
    },
    {
      title: "소속",
      dataIndex: "department",
      width: "100px"
    },
    {
      title: "직책",
      dataIndex: "responsibility",
      width: "100px"
    },
    {
      title: "직급",
      dataIndex: "position",
      width: "100px"
    },
    {
      title: "MFA 사용여부",
      dataIndex: "google_otp_use_yn",
      width: "150px",
      render: (_) => {
        return (
          <Switch disabled={true} checked={_ === "Y" ? true : false}/>
        )
      }
    },
    {
      title: "계정상태",
      dataIndex: "status",
      render: (_) => (_ === "1" ? "정상" : "해지"),
      width: "100px"
    },
    {
      title: "관리영역",
      dataIndex: "assignedMenuGroupName",
      width:"300px",
      render: (_, record) => {
        // console.log(_);
        // console.log(record);
        return (
          <div>
            {_.map((el, idx) => (
              <Tag key={idx}>{el}</Tag>
            ))}
          </div>
        );
      },
    },
    {
      title: "최초등록자(등록일시) 및 최종수정자(수정일시)",
      dataIndex: "updateInfo",
    },
  ];

  // 관리영역 필터옵션을 설정하기 위해 필요
  const menuGroupSelectList = menuGroupLists.map((el) => {
    return {
      value: el.id,
      label: el.menu_group_name,
    };
  });
  menuGroupSelectList.unshift({ value: "전체", label: "관리영역:전체" });

  const fetchData = () => {
    setLoading(true);

    const dataSource = adminManageInfo.userAssignedMenuGroup.reduce(
      (acc, ele, idx) => {
        const statusFilter =
          filter.status === "전체"
            ? true
            : filter.status === ele.status
            ? true
            : false;
        const menuGroupFilter =
          filter.menuGroup === "전체"
            ? true
            : ele.assignedMenuGroupId.includes(filter.menuGroup)
            ? true
            : false;
        const searchFilter =
          filter.search === ""
            ? true
            : ele.name.includes(filter.search) ||
              ele.email.includes(filter.search)
            ? true
            : false;

        // const rowKey = acc.length + 1; //순번을 오름차순으로 하기 위함
        const rowKey = adminManageInfo.userAssignedMenuGroup.length - idx // 순번을 내림차순으로 하기 위함

        if (statusFilter && menuGroupFilter && searchFilter) {
          acc.push({
            rowKey: rowKey,
            index: idx,
            id: ele.id,
            email: ele.email,
            name: ele.name,
            phone: ele.phone,
            department: ele.department,
            responsibility: ele.responsibility,
            position: ele.position,
            google_otp_use_yn: ele.google_otp_use_yn,
            status: ele.status,
            assignedMenuGroupId: ele.assignedMenuGroupId,
            assignedMenuGroupName: ele.assignedMenuGroupName,
            updateInfo: ele.updateInfo,
            thumbnail: ele.thumbnail,
            description: ele.description,
            create_user_name: ele.create_user_name,
            update_user_name: ele.update_user_name,
            create_datetime: ele.create_datetime,
            update_datetime: ele.update_datetime,
          });
        }
        return acc;
      },
      []
    );
    
    dataSource.forEach((ele,idx)=>{
      ele.rowKey = dataSource.length - idx
      return ele
    })

    setData(dataSource);
    setLoading(false);
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        // total: 100, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
        total: dataSource.length, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
      },
    });
  };
//   console.log(data);
  function handleChangeStatus(value) {
    setFilter({ ...filter, status: value });
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination, current:1
      }
    })
  }
  function handleChangeMenuGroup(value) {
    setFilter({ ...filter, menuGroup: value });
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination, current:1
      }
    })
  }
  function onSearch(value) {
    setFilter({ ...filter, search: value });
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination, current:1
      }
    })
  }

  // ----------------여기부터 팝업관련 함수
  function emailSearchHandler(value) {
    setEmailValidator(value);
  }

  function resetValue() {
    userRef.current.resetFields();
    setEmailValidator(null);
  }

  function createOkHandler() {
    // 여기에 운영자 등록 로직

    userRef.current
      .validateFields()
      .then((data) => {
        if (emailValidator === null) {
          Modal.warn({ title: "이메일의 사용가능 여부를 체크하세요." });
        } else if (emailValidator === false) {
          Modal.error({
            title: "이미 사용중인 이메일입니다. 다른 이메일을 입력하세요.",
          });
        } else {
        //   console.log(data);

          axios
            .post(`${backend}/admin_manage/insert_user`, {
              data,
              create_user_id: userInfo ? userInfo.id : null,
            })
            .then((data) => {
            //   console.log(data);
            setCreatePopup(false);
            resetUsers()
              Modal.success({
                title: "등록 완료",
                okText: "확인",
                content: "정상적으로 등록 되었습니다.",
                afterClose: () =>{
                  setEmailValidator(null)
                }
              });
            })
            .catch((err) => {
              if (err.response.status === 401) {
                Modal.error({
                  title: "인증 에러",
                  content: "인증이 만료되었습니다. 다시 로그인 해주세요.",
                  afterClose: () => {
                    dispatch(authAction(false, null));
                  },
                });
              }
              console.log(err);
            });
        }
      })
      .catch((err) => {
        return err;
      });
    // const info = userRef.current.getFieldsValue()

  }

  function createCancelHandler() {
    setCreatePopup(false);
    setEmailValidator(null);
    userRef.current.resetFields();
  }
  function editOkHandler() {
    // 여기에 운영자 수정 로직
    // console.log(userRef.current.getFieldsValue());

    userRef.current
    .validateFields()
    .then((data) => {
    // const changedUserInfo = userRef.current.getFieldsValue();
    axios
      .post(`${backend}/admin_manage/edit_user`, {
        changedUserInfo : data,
        update_user_id: userInfo ? userInfo.id : null,
      })
      .then((data) => {
        setEditPopup([false, {}]);
        resetUsers();
        Modal.success({
          title: "수정 완료",
          okText: "확인",
          content: "정상적으로 수정 되었습니다.",
          // afterClose: () => {
          // },
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          Modal.error({
            title: "인증 에러",
            content: "인증이 만료되었습니다. 다시 로그인 해주세요.",
            afterClose: () => {
              dispatch(authAction(false, null));
            },
          });
        }
        console.log(err);
      });
    })
    .catch(err=>{
        console.log(err)
    })
  }
  function editCancelHandler() {
    setEditPopup([false, {}]);
  }
  //-----------------------
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(tableParams), JSON.stringify(filter), adminManageInfo]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };

  return (
    <div style={{display:"flex", flexDirection:"column", height:"100%"}}>
      <Modal
        destroyOnClose={true}
        open={createPopup}
        title="운영자 등록"
        maskClosable={false}
        onCancel={createCancelHandler}
        width={"80%"}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={resetValue}>내용 초기화</Button>
            <span>
              <Button type="primary" onClick={createOkHandler}>
                등록
              </Button>
              <Button onClick={createCancelHandler}>취소</Button>
            </span>
          </div>
        }
      >
        <InsertAdminUser
          menuGroupLists={menuGroupLists}
          emailValidator={emailValidator}
          emailSearchHandler={emailSearchHandler}
          ref={userRef}
        />
      </Modal>
      <Modal
        destroyOnClose={true} //이 옵션이 있어야 창을 닫을 때 초기화가 됨.
        open={editPopup[0]}
        title="운영자 수정"
        maskClosable={false}
        onCancel={editCancelHandler}
        width={"80%"}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={resetValue}>내용 초기화</Button>
            <span>
              <Button type="primary" onClick={editOkHandler}>
                수정
              </Button>
              <Button onClick={editCancelHandler}>취소</Button>
            </span>
          </div>
        }
      >
        <EditAdminUser
          editPopup={editPopup[1]}
          menuGroupLists={menuGroupLists}
          ref={userRef}
        />
      </Modal>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span>운영자 목록</span>
        <span>
          <Input.Search
            placeholder="계정이나 이름을 입력해주세요."
            onSearch={onSearch}
            allowClear={true}
            style={{
              width: 250,
              marginLeft: "5px",
            }}
          />
          <Select
            defaultValue="전체"
            style={{
              width: 120,
              marginLeft: "5px",
              textAlign: "left"
            }}
            onChange={handleChangeStatus}
            options={[
              {
                value: "전체",
                label: "계정상태:전체",
              },
              {
                value: "1",
                label: "정상",
              },
              {
                value: "0",
                label: "해지",
              },
            ]}
          />
          <Select
            defaultValue="전체"
            style={{
              width: 120,
              marginLeft: "5px",
              textAlign: "left"
            }}
            onChange={handleChangeMenuGroup}
            options={menuGroupSelectList}
          />
          <Button
            style={{ marginLeft: "5px" }}
            onClick={() => {
              setCreatePopup(true);
            }}
          >
            <PlusOutlined />
            운영자 등록
          </Button>
        </span>
      </div>
      <div style={{ width:"100%", height:"100%", overflow:"auto"}}>
      <Table
        className="pageTable"
        columns={columns}
        rowKey="index"
        dataSource={data}
        pagination={tableParams.pagination}
        loading={loading}
        onChange={handleTableChange}
        style={{whiteSpace:"pre-line"}}
        scroll={{ x: 1920, y:"100%" }}
      />
      </div>
    </div>
  );
};

export default AdminUser;
